import angular from 'angular';
import uiRouter from 'angular-ui-router';
import profileComponent from './profile.component';

import Registry from './registry/registry';
import Security from './security/security';
import Documents from './documents/documents';
import Account from './account/account';

const profileModule = angular.module('tinaba.components.profile', [
  uiRouter,
  Registry.name,
  Security.name,
  Documents.name,
  Account.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('profile', {
      url: '/profile',
      template: '<profile></profile>',
      redirect: 'profile.registry'
    });
})

.component('profile', profileComponent);

export default profileModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/profile.js
 **/